import { createContext, useContext, useEffect, useMemo, useState, type ReactNode } from 'react';
import { defaultPublicIntegration, type PublicIntegrationSnapshot } from './publicIntegrationTypes';
import { fetchPublicIntegrationConfig } from '@frontend/api-clients/publicIntegrationClient';

const PublicIntegrationContext = createContext<PublicIntegrationSnapshot>(defaultPublicIntegration);

export function PublicIntegrationProvider({ children }: { children: ReactNode }) {
  const [snapshot, setSnapshot] = useState<PublicIntegrationSnapshot>(defaultPublicIntegration);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const config = await fetchPublicIntegrationConfig();
        if (!cancelled) setSnapshot(config);
      } catch {
        /* keep defaults */
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const value = useMemo(() => snapshot, [snapshot]);
  return <PublicIntegrationContext.Provider value={value}>{children}</PublicIntegrationContext.Provider>;
}

export function usePublicIntegration(): PublicIntegrationSnapshot {
  return useContext(PublicIntegrationContext);
}
